module.exports = __webpack_public_path__ + "img/intereventos.b016d861.png";